import { render, staticRenderFns } from "./VoucherArchive.vue?vue&type=template&id=d0b446d4"
import script from "./VoucherArchive.vue?vue&type=script&lang=ts"
export * from "./VoucherArchive.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports